import { Flow } from "./Flow";
import { Observable } from "rxjs";

export class Plan {
    public name: string;
    public items: DeployItem[];
    public environmentSource: string;
    public environmentDestination: string;

    constructor(){
        this.items = [];
    }
    public type = "plan";
}

export class DeployItem {

    public environmentSource: string;
    public flowSource: string;
    public environmentDestination: string;
    public flowDestination: string; 
    public replacements: DeployReplaceItem[];

    constructor(){
        this.replacements = [];
    }

    // public get _flowSource(): Flow {
    //     return this._flowSource;
    // }
    // public set _flowSource(value: Flow) {
    //     this._flowSource = value;
    // }
    // public get _flowDestination(): Flow {
    //     return this._flowDestination;
    // }
    // public set _flowDestination(value: Flow) {
    //     this._flowDestination = value;
    // }

}

export class DeployReplaceItem {

    public type: string;
    public name: string;
    public source: string;
    public destination: string;
    public path: string[];
    public description: string;
    public ignore: boolean;

    constructor(){
        this.path = [];
    }

}